//@ts-nocheck
import { t } from '@web-solutions/module-localization';

import { Text } from 'core/ui-elements';

import { Base } from '../base';

import classes from '../../style.module.scss';

const tKey = 'core.subscription.error_popup.decline_reasons.subscription_locked';

interface Props {
  onClick: () => void;
}

export const SubscriptionLocked: React.FC<Props> = ({ onClick }) => {
  return (
    <Base subtitle={t(`${tKey}.subtitle`)} onClick={onClick}>
      <Text
        className={classes.baseText}
        components={{
          email: (
            <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`} className={classes.email} />
          ),
        }}
        tOptions={{ email: `${process.env.REACT_APP_SUPPORT_EMAIL}` }}
      >
        {`${tKey}.text`}
      </Text>
    </Base>
  );
};
